// extracted by mini-css-extract-plugin
module.exports = {"layout":"ResponsivePage_layout__25x3f"};